/**
 * Enum representing different user roles in the system.
 * @enum {string}
 * @readonly
 */
export const UserRoles = {
  Administrator: 'admin',
  Shareholder: 'eim_shareholder',
  EimAdministrator: 'eim_admin',
  EimOperator: 'eim_operator',
  EimViewer: 'eim_viewer',
  Observer: 'observer', // Observer role is used for the read-only access level of the admins
};

export const SysAdminRoles = [UserRoles.Administrator];
